import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import api from "../pages/chat/api";
import Cookies from "js-cookie";
import { getFreshAccessToken } from "../pages/chat/api";
let activeChatSocket = null;
let shouldStopStreaming = false;
export const fetchExcelChat = createAsyncThunk(
  'excelChat/fetchExcelChat',
  async ({ excelKey, clientMessage,chat_module = "excel",id }, { rejectWithValue, dispatch }) => {
    shouldStopStreaming = false;
    let token = await getFreshAccessToken();
    if (!token) {
      return rejectWithValue('No authorization token found');
    }
    const wsUrl = `wss://stagingbackend.docusensa.com/ws/qdrant-chat/${excelKey}/?token=${token}`;
shouldStopStreaming = false;
    // const wsUrl = `wss://stagingbackend.docusensa.com/ws/qdrant-excelchat/${excelKey}/?token=${token}`;
    if (activeChatSocket && activeChatSocket.readyState !== WebSocket.CLOSED) {
  activeChatSocket.close();
}
    const socket = new WebSocket(wsUrl);
activeChatSocket = socket;
    return new Promise((resolve, reject) => {
      let accumulatedAnswer = '';
      let botMessageId = null;
      let runId = null;
      let generatedQuestions = null;

      socket.onopen = () => {
        socket.send(JSON.stringify({ client_message: clientMessage,chat_module: chat_module,id }));
        dispatch(updateStatus('loading'));
        dispatch(updatePartialAnswer(''));
      };

      socket.onmessage = (event) => {
          if (shouldStopStreaming) {
          console.warn("🛑 shouldStopStreaming is true → Closing WebSocket...");
          socket.close();
          dispatch(updateStatus("stopped")); // Optional UI update
          return;
        }
        
    
        try {
            const data = JSON.parse(event.data);
    
            
            if (data.error) {
                console.error("WebSocket Error:", data.error);
                dispatch(updateStatus("failed"));
                dispatch(updateFinalAnswer(`Error: ${data.error}`)); // Display error in UI
                socket.close();
                return;
            }
    
            if (
              data.type !== "info" &&
              data.status !== "connected" &&
              data.message
            ) {
                accumulatedAnswer += data.message;
                dispatch(updatePartialAnswer(accumulatedAnswer));
            }
    
            if (data.type === 'final') {
                botMessageId = data.data.bot_message_id;
                runId = data.data.run_id;
                generatedQuestions = data.data.generated_questions || ""; 
                const barChartData = data.data.charts?.bar_chart || null;

    
                dispatch(updateGeneratedQuestions(generatedQuestions));
                dispatch(updateFinalAnswer(accumulatedAnswer));
                dispatch(updateBotMessageInfo({ botMessageId, runId, generatedQuestions }));
                dispatch(updateBarChart(barChartData));
                socket.close();
                resolve(accumulatedAnswer);
            }
        } catch (error) {
            console.error("Error parsing WebSocket message:", event.data, error);
        }
    };
    

      socket.onerror = (error) => {
        console.error('WebSocket error:', error);
        reject(rejectWithValue('WebSocket connection error'));
      };

      socket.onclose = () => {
      };
    });
  }
);




export const fetchExcelSummary = createAsyncThunk(
  "excelChat/fetchExcelSummary",
  async ({ excelKey, clientMessage,chat_module = "excel" }, { rejectWithValue, dispatch }) => {
    let token = await getFreshAccessToken();
    if (!token) {
      return rejectWithValue("No authorization token found");
    }

    const wsUrl = `wss://stagingbackend.docusensa.com/ws/pdf-summary-and-chats/${excelKey}/?token=${token}`;

    return new Promise((resolve, reject) => {
      const socket = new WebSocket(wsUrl);
      let accumulatedAnswer = "";
      let botMessageId = null;
      let runId = null;
      let generatedQuestions = null;

      socket.onopen = () => {
        socket.send(JSON.stringify({ client_message: clientMessage,chat_module: chat_module }));
        dispatch(updateStatus("loading"));
        dispatch(updatePartialAnswer(""));
      };

      socket.onmessage = (event) => {

        try {
          const message = event.data.startsWith("data: ")
            ? event.data.slice(6)
            : event.data;
          const data = JSON.parse(message);

          if (!data) {
            console.error("⚠️ Received empty data from WebSocket!");
            return;
          }

          if (data.status === "connected") {
            return;
          }

          if (
            data.type !== "info" &&
            data.status !== "connected" &&
            data.message
          ) {
            accumulatedAnswer += data.message;
            dispatch(updatePartialSummary(accumulatedAnswer));
          }

          if (data.type === "final") {

            botMessageId = data.data?.bot_message_id;
            runId = data.data?.run_id;
            const summary = data.data?.summary || "";
            generatedQuestions = data.data?.example_questions || "";

            const firstChar = data.data?.first_char || data.excel_details?.first_char || "";
  const lastChar = data.data?.last_char || data.excel_details?.last_char || "";
  const initials = `${firstChar}${lastChar}`.toUpperCase();
  const formattedTimestamp = data.data?.summary_generated_at || data.excel_details?.summary_generated_at;


            if (!summary) {
              console.warn("⚠️ No summary received from WebSocket!");
            }

 

            dispatch(updateFinalSummary(summary));
            dispatch(updateSummaryStatus("succeeded"));
            dispatch(updateGeneratedQuestions(generatedQuestions));
            dispatch(updateSummaryMetadata({ userInitials: initials, formattedTimestamp }));

            dispatch(updateBotMessageInfo({ botMessageId, runId, generatedQuestions }));
            dispatch(updateStatus("succeeded"));

            socket.close();
            resolve(summary);
          }
        } catch (error) {
          console.error("❌ Error parsing WebSocket message:", event.data, error);
          reject(rejectWithValue("WebSocket message parsing error"));
        }
      };

      socket.onerror = (error) => {
        console.error("❌ WebSocket error:", error);
        socket.close();
        reject(rejectWithValue("WebSocket connection error"));
      };

      socket.onclose = () => {
      };
    });
  }
);





const excelChatSlice = createSlice({
  name: 'excelChat',
  initialState: {
    messages: [],
    partialAnswer: '',
    finalAnswer: '',
    status: 'idle',
     barChart: null,
    error: null,
    botMessageId: null, 
    runId: null,
    generatedQuestions: null,
    feedback: {},
    formattedTimestamp: "",
    userInitials: "",
  },
  initialState: {
    messages: [],
    partialAnswer: "",
    finalAnswer: "",
    partialSummary: "",
    finalSummary: "",
    status: "idle",
    summaryStatus: "idle",
    error: null,
    summaryError: null,
    botMessageId: null,
    runId: null,
    generatedQuestions: null,
    feedback: {},
    formattedTimestamp: "",
    userInitials: "",
  },
  reducers: {
    resetExcelChatState: (state) => {
      state.messages = [];
      state.partialAnswer = '';
      state.finalAnswer = '';
      state.status = 'idle';
      state.error = null;
      state.botMessageId = null; 
      state.runId = null;
      state.generatedQuestions = null;
      state.feedback = {}; 
    },
    updatePartialAnswer: (state, action) => {
      state.partialAnswer = action.payload;
    },
    updateFinalAnswer: (state, action) => {
      state.finalAnswer = action.payload;
    },
    updateBarChart: (state, action) => {
    state.barChart = action.payload;
},

    updateBotMessageInfo: (state, action) => {
      const { botMessageId, runId , generatedQuestions } = action.payload;
      state.botMessageId = botMessageId;
      state.runId = runId;
      state.generatedQuestions = generatedQuestions; 
    },
    updateFeedback: (state, action) => {
      const { messageId, feedbackType } = action.payload;
      state.feedback[messageId] = feedbackType;
    },
    updateStatus: (state, action) => {
      state.status = action.payload;
    },
    updatePartialSummary: (state, action) => {
      state.partialSummary = action.payload;
    },
    updateFinalSummary: (state, action) => {
      state.finalSummary = action.payload;
    },
    updateSummaryStatus: (state, action) => {
      state.summaryStatus = action.payload;
    },
    updateGeneratedQuestions: (state, action) => {
      state.generatedQuestions = action.payload; 
    },
  
    updateSummaryMetadata: (state, action) => {
      state.formattedTimestamp = action.payload.formattedTimestamp || "N/A";
      state.userInitials = action.payload.userInitials || "N/A";
    },
    resetStopStreaming: (state) => {
        shouldStopStreaming = false;
      },
      stopStreaming: (state) => {
      shouldStopStreaming = true;
    }
    
    
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchExcelChat.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(fetchExcelChat.fulfilled, (state, action) => {
        state.messages.push(action.payload);
        state.status = 'succeeded';
      })
      .addCase(fetchExcelSummary.pending, (state) => {
        state.summaryStatus = "loading";
      })
      .addCase(fetchExcelSummary.fulfilled, (state, action) => {
        const excelDetails = action.meta?.arg?.excel_details || {};
        const firstChar = excelDetails.first_char || "";
        const lastChar = excelDetails.last_char || "";
        const initials = `${firstChar}${lastChar}`.toUpperCase();
      
        state.userInitials = initials || "N/A";
        state.summaryStatus = "succeeded";
      })
      
      .addCase(fetchExcelSummary.rejected, (state, action) => {
        state.summaryError = action.payload;
        state.summaryStatus = "failed";
      })
      .addCase(fetchExcelChat.rejected, (state, action) => {
        state.error = action.payload;
        state.status = 'failed';
      });
  },
});
export const {  resetExcelChatState, updatePartialAnswer, updatePartialSummary,updateBarChart,
  updateFinalSummary,
  updateSummaryStatus,
  updateGeneratedQuestions, updateFinalAnswer, stopStreaming,
  resetStopStreaming, updateBotMessageInfo, updateStatus,updateSummaryMetadata, } = excelChatSlice.actions;
export default excelChatSlice.reducer;